import _isNil from "lodash/isNil";
import i18n from '@signavio/i18n';
function number({
  value,
  type
}) {
  if (_isNil(value) || value.length === 0) {
    return [];
  }
  if (!_isNil(type.elementType.minValue) && value[value.length - 1] < type.elementType.minValue) {
    return [i18n('The given value "__value__" may not be smaller than "__minValue__"', {
      value: value[value.length - 1],
      minValue: type.elementType.minValue
    })];
  }
  if (!_isNil(type.elementType.maxValue) && value[value.length - 1] > type.elementType.maxValue) {
    return [i18n('The given value "__value__" may not be greater than "__maxValue__"', {
      value: value[value.length - 1],
      maxValue: type.elementType.maxValue
    })];
  }
  return [];
}
export default number;